import axios from "axios";

/**
 * LF360-2100 — connecting an AI assistant (Claude, ChatGPT) to LF360 over MCP.
 *
 * The assistant starts the connection and sends the browser to the consent
 * screen with the id of its request; these calls answer that screen and the
 * list of the user's connections. All of them run in the portal session.
 * Approve and deny answer `redirectUrl`, the address to send the browser back
 * to the assistant.
 */
const getAuthorization = (requestId) =>
  axios.get(`api/v1/mcp/authorizations/${encodeURIComponent(requestId)}`);

const approve = (requestId, { projectId, scopes, expiresInDays }) =>
  axios.post(`api/v1/mcp/authorizations/${encodeURIComponent(requestId)}/approve`, {
    projectId,
    scopes,
    expiresInDays,
  });

const deny = (requestId) =>
  axios.post(`api/v1/mcp/authorizations/${encodeURIComponent(requestId)}/deny`);

const getConnections = () => axios.get("api/v1/mcp/connections");

const revokeConnection = (connectionId) =>
  axios.delete(`api/v1/mcp/connections/${encodeURIComponent(connectionId)}`);

// The user's own AI tool calls, newest first, 30 a page: { calls, page, hasMore }.
const getCalls = (params = {}) => axios.get("api/v1/mcp/calls", { params });

// LF360-2100 stage 1 — AI connectors in the open project (Organization admins):
// the project's switch, its live connections, and revoking any of them.
const getProjectSettings = () => axios.get("api/v1/mcp-settings");

// `changes`: { mcpEnabled?, maxPhase? }; a field left out stays as it is.
const updateProjectSettings = (changes) => axios.put("api/v1/mcp-settings", changes);

const revokeProjectConnection = (connectionId) =>
  axios.delete(`api/v1/mcp-settings/connections/${encodeURIComponent(connectionId)}`);

// The project's AI call log, the Audit trail tab: { calls, page, hasMore }.
const getProjectCalls = (params = {}) => axios.get("api/v1/mcp-call-logs", { params });

const ApiMcp = {
  getAuthorization,
  approve,
  deny,
  getConnections,
  revokeConnection,
  getCalls,
  getProjectSettings,
  updateProjectSettings,
  revokeProjectConnection,
  getProjectCalls,
};

export default ApiMcp;
